import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

import type { AvpFilterExpressionData } from './avp-filter-expression-common';

/**
 * Data payload for rendering an updated AVP filter expression.
 */
export type AvpFilterExpressionUpdateData = AvpFilterExpressionData & {
	/**
	 * The identifier of the filter expression that was updated.
	 */
	expressionId: string;
};

/**
 * Properties for the AVP filter expression update command.
 *
 * @extends CommandProperties
 */
export interface AvpFilterExpressionUpdateCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the filter expression update request.
	 */
	key: string;
	/**
	 * The data payload containing the updated filter expression tree.
	 */
	data: AvpFilterExpressionUpdateData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}

/**
 * A command sent by a bridge API client to render an updated AVP filter expression.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to render the updated AVP filter expression tree after an update.
 */
export const AvpFilterExpressionUpdateCommand: CommandConstructor<
	AvpFilterExpressionUpdateCommandProperties,
	SerializableValue
> = createCommand<AvpFilterExpressionUpdateCommandProperties>(
	'avp-filter-expression-update-command',
);
